<template>
    <div class="content">
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form :inline="true" size="mini" :model="search">
  
            <el-form-item label="时间">
               <el-select v-model="search.time_type" class="w100" clearable placeholder="请选择">
                <el-option
                  v-for="item in options.time_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-date-picker
                v-model="search.date"
                type="daterange"
                class="w220"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="onDateChange"
              />
            </el-form-item>
            <el-form-item label="门店/门诊" v-if="!userInfo.shop_id">
              <el-select
                v-model="search.shop_id"
                clearable
                remote
                filterable
                :remote-method="remoteMethod"
                placeholder="请输入门店/门诊"
                class="w120 mr20"
              >
                <el-option
                  v-for="item in options.shop_id"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>
             <el-form-item label="护理师">
              <el-input
                v-model="search.person_name"
                maxlength="30"
                class="w120 mr20"
                placeholder="请输入护理师名称"
                clearable
              />
          </el-form-item>
  
          <el-form-item label="卡项名称" >
                <el-input
                  v-model="search.serve_name"
                  maxlength="30"
                  class="w150 mr20"
                  placeholder="请输入卡项名称"
                  clearable
                />
          </el-form-item>
            <el-form-item label="顾客名称" >
              <el-input
                v-model="search.customer_name"
                maxlength="30"
                class="w100"
                placeholder="请输入顾客名称"
                clearable
              />
            </el-form-item>
            <el-form-item label="顾客电话" >
              <el-input
                v-model="search.telephone"
                maxlength="30"
                class="w150"
                placeholder="请输入顾客电话"
                clearable
              />
            </el-form-item>
            <el-form-item label="会员等级" >
              <el-select
                v-model="search.membership_leve"
                clearable
                class="w100"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options.membership_leve"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="本月是否核销">
              <el-select v-model="search.is_month_verify" clearable class="w100" placeholder="请选择">
                <el-option label="是" :value="1" />
                <el-option label="否" :value="0" />
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right;">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        </el-col>
      </el-row>
      <el-row class="mt30">
        <div style="margin-bottom:10px;">
          <el-button type="primary" size="mini" @click="exportData('export')">导出</el-button>
        </div>
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="建档时间" prop="customer_create_time" width="100" />

            <ElTableColumn label="护理师" prop="person_name" width="90" />

            <ElTableColumn label="顾客姓名" prop="customer_name" width="90" />

            <ElTableColumn label="手机号" prop="telephone" width="110" />

            <ElTableColumn label="会员等级" prop="grade_name" width="80" />

            <ElTableColumn label="账户金额" prop="account_money" width="90" />

            <ElTableColumn label="卡项名称" prop="serve_name" min-width="140" show-overflow-tooltip />

            <ElTableColumn label="开卡时间" prop="create_time" width="100" />

            <ElTableColumn label="成交金额" prop="cj_money" width="90" />

            <ElTableColumn label="卡项次数/到期时间" width="150">
              <template slot-scope="{ row }">
                <span v-if="row.service_type == 1">{{ row.start_time }} 至 {{ row.end_time }}</span>
                <span v-else>{{ row.num }}次</span>
              </template>
            </ElTableColumn>

            <ElTableColumn label="最近核销时间" prop="last_verify_time" width="130" />

            <ElTableColumn label="剩余次数" prop="yy_num" width="70" />

            <ElTableColumn label="本月是否核销" width="100" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="row.is_month_verify == 1 ? 'success' : 'info'" size="mini">
                  {{ row.is_month_verify == 1 ? '是' : '否' }}
                </el-tag>
              </template>
            </ElTableColumn>

            <!-- <ElTableColumn label="操 作" fixed="right" width="90">
              <template slot-scope="{ row }">
                <span class="theme ml20" @click="tapDetail(row.id)">查 看</span>
              </template>
            </ElTableColumn> -->
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
      </el-row>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { getServiceSurplus,getGradeList } from "@/api/client";
  import { getShopList } from "@/api/shop";
  
  class Search {
    person_name = ""; // 护理师
    customer_name = ""; // 顾客名称
    telephone = ""; // 顾客电话
    membership_leve = ""; // 会员等级
    shop_id = ""; // 店铺
    serve_name = ""; // 卡项名称
    time_type = ""; // 时间类型 1开卡时间 2建档时间
    start_time = ""; // 开始日期
    end_time = ""; // 结束日期
    date = []; // 日期范围
    is_month_verify = ""; // 本月是否核销 1是 0否
  }
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class Options {
    constructor() {
      this.shop_id = []; // 店铺
    }
    membership_leve = []; // 会员等级
    time_type = [
      { value: 1, label: "开卡时间" },
      { value: 2, label: "建档时间" }
    ];
  }
  
  export default {
    name: "ServeRecord",
    components: {
      pagination
    },
    props: {
      clienId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        search: new Search(),
        options: new Options(),
        page: new Page(),
        list: []
      };
    },
    mounted() {
      this.getList();
      getGradeList().then(res => {
        this.options.membership_leve = res.list || [];
      });
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    methods: {
      // 日期选择
      onDateChange(val) {
        if (val && val.length === 2) {
          this.search.start_time = val[0];
          this.search.end_time = val[1];
        } else {
          this.search.start_time = "";
          this.search.end_time = "";
        }
      },
      // 获取列表
      getList(option) {
        if (option === "search") this.page = new Page();
        getServiceSurplus({
          ...this.search,
          ...this.page,
          export: 0,
        }).then(res => {
          this.list = res.list;
          this.page.total = res.dataCount;
        });
      },
      // 导出
      exportData() {
        getServiceSurplus({
          ...this.search,
          export: 1
        }).then(res => {
          window.open(res.url);
        });
      },
      // 搜索门店
      remoteMethod(e) {
        getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
          this.options.shop_id = res.list;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  